import { render, staticRenderFns } from "./CotizaComoAgente.vue?vue&type=template&id=bf6f2e48&scoped=true"
import script from "./CotizaComoAgente.vue?vue&type=script&lang=js"
export * from "./CotizaComoAgente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf6f2e48",
  null
  
)

export default component.exports